"use strict";
(function() {

function run() {
	let e;

	e = document.querySelectorAll(".open-search");
	if (e) {
		e.forEach(elm => elm.addEventListener("click", function() {
			document.querySelector("#modal-menu").dataset.filter = "search";
		}))
	}
	e = document.querySelectorAll(".open-menu");
	if (e) {
		e.forEach(elm => elm.addEventListener("click", function() {
			document.querySelector("#modal-menu").dataset.filter = "menu";
		}))
	}

	// set focus on search box when opened
	// note: focus can't be set on the previous click handler, as the menu is not open yet at that point
	e = document.querySelector("#modal-menu");
	e.addEventListener("toggle", event => {
		if (event.newState == "open" && e.dataset.filter == "search") {
			document.querySelector(".menu-items [aria-current] input").focus();
		}
	})
}


/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
if (!(document.querySelector("body").classList.contains("isEditing"))) {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", run);
	} else {
		run();
	}
}

})();
